export const normalizeIvSeq = (seq) => {
  if (seq === null || seq === undefined) return "";
  return String(seq);
};

export const getIvDataIndex = (ivData, selInverter) => {
  const seqArray = ivData?.seq;
  if (!Array.isArray(seqArray)) return -1;

  const targetSeq = normalizeIvSeq(selInverter);
  return seqArray.findIndex((seq) => normalizeIvSeq(seq) === targetSeq);
};

export const getIvFieldValue = (ivData, field, selInverter, fallback = undefined) => {
  const value = ivData?.[field];

  if (Array.isArray(value)) {
    const dataIndex = getIvDataIndex(ivData, selInverter);
    if (dataIndex === -1) return fallback;

    const selectedValue = value[dataIndex];
    return selectedValue === undefined || selectedValue === null ? fallback : selectedValue;
  }

  return value === undefined || value === null ? fallback : value;
};
